// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"dbbcd192","161":"cb9747fd","239":"dfdb0d71","324":"a17fd4c0","455":"39e07435","717":"2cce4cf9","838":"5b933b27","977":"fb55a997"}[chunkId] + ".chunk.js";
};